import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(name, password);

    if (!result.success) {
      setError(result.error);
    }

    setLoading(false);
  };

  const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#1a1a1c',
    color: '#e8e6e3',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  };

  const cardStyle = {
    width: '100%',
    maxWidth: '400px',
    padding: '32px',
    background: '#2a2a2e',
    borderRadius: '8px',
    border: '1px solid #3a3a3e',
  };

  const titleStyle = {
    fontSize: '24px',
    fontWeight: 600,
    marginBottom: '24px',
    textAlign: 'center',
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '6px',
    fontSize: '13px',
    color: '#999',
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    background: '#1a1a1c',
    border: '1px solid #3a3a3e',
    borderRadius: '4px',
    color: '#e8e6e3',
    fontSize: '14px',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    width: '100%',
    padding: '12px',
    background: '#e8a87c',
    color: '#1a1a1c',
    border: 'none',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: loading ? 'not-allowed' : 'pointer',
    opacity: loading ? 0.6 : 1,
  };

  const errorStyle = {
    padding: '10px',
    background: '#d4726a22',
    border: '1px solid #d4726a44',
    borderRadius: '4px',
    color: '#d4726a',
    fontSize: '13px',
  };

  const linkStyle = {
    textAlign: 'center',
    fontSize: '13px',
    color: '#999',
    marginTop: '16px',
  };

  const linkTextStyle = {
    color: '#e8a87c',
    textDecoration: 'none',
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h1 style={titleStyle}>Sign In</h1>

        {error && (
          <div style={errorStyle}>{error}</div>
        )}

        <form onSubmit={handleSubmit} style={formStyle}>
          <div>
            <label style={labelStyle}>Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoFocus
              disabled={loading}
              style={inputStyle}
            />
          </div>

          <div>
            <label style={labelStyle}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              style={inputStyle}
            />
          </div>

          <button type="submit" disabled={loading} style={buttonStyle}>
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </form>

        <div style={linkStyle}>
          Don't have an account? <Link to="/signup" style={linkTextStyle}>Sign up</Link>
        </div>
      </div>
    </div>
  );
}
